import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
    en: {
        translation: {
            label_idioma: "Language",
            label_plataforma_checklist: "Checklist Platform",
            label_usuario: "User",
            label_contrasena: "Password",
            label_ingresar: "Enter",
            label_registrarse: "Sign up",
            label_registrar_usuario: "Register User",
            label_nombre: "Name",
            label_apellido: "Last Name",
            label_nota: "Note",
            label_siguiente: "Next",
            label_atras: "Back",
            label_crear_cuenta: "Create Account",
            label_password: "Password",
            label_confirmar_password: "Confirm Password",
            label_ver_detalles: "View Details",
            label_vehiculo: "Vehicle",
            label_fecha_registro: "Registration Date",
            label_secciones: "Sections",
            label_critico: "Critical",
            label_seleccione_unidad: "Select Vehicle",
            label_fecha_inicio: "Start Date",
            label_fecha_fin: "End Date",
            label_cantidad: "Total",
            label_total_critico: "Total Critical",
            label_si: "Yes",
            label_no: "No",
            label_codigo: "Code",
            label_enviar_correo: "Send Email",
            label_seleccione_correos: "Select Emails",
            label_enviar_mensaje_via_whatsapp: "Send Message via WhatsApp",
            label_seleccione_telefonos: "Select Telephones",
            label_validar_conductor: "Validate Driver",
            label_activo: "Active",
            label_no_activo: "Inactive",
            label_tipo_input: "Tipo Input",
            label_ejemplo: "Example",
            label_mover_input_arriba: "Move Input Up",
            label_mover_input_abajo: "Move Input Down",
            label_seleccione_input: "Select Input",
            label_datos_extra_requeridos: "Extra Required Data",
            label_respuesta_checklist: "Checklist Response",
            label_nombre_checklist: "Checklist Name",
            label_tipo_checklist: "Checklist Type",
            label_area: "Area",
            label_ciudad: "City",
            label_tipo_vehiculo: "Vehicle Type",
            label_marca_vehiculo: "Vehicle Brand",
            label_tipo_carroceria: "Vehicle Body Type",
            label_tipo_combustible: "Fuel Type",
            label_nombre_seccion: "Section Name",
            label_preguntas: "Questions",
            label_seccion_nro: "Section Number",
            label_manejo_defensivo: "Defensive Driving",
            label_opciones_respuesta_habilitadas: "Enabled Response Options",
            label_opciones_respuesta_deshabilitadas: "Disabled Response Options",
            label_tipo_pregunta: "Question Type",
            label_mover_arriba: "Move Up",
            label_mover_abajo: "Move Down",
            label_no_tiene_nombre_seccion: "HAS NO NAME SECTION",
            label_numero_pregunta: "Question Number",
            label_no_tiene_titulo_pregunta_descripcion: "HAS NO QUESTION TITLE/DESCRIPTION",
            label_no_tiene_opciones_respuesta: "HAS NO RESPONSE OPTIONS",
            label_seleccione_tipo_checklist: "Select Checklist Type",
            label_seccion: "Section",
            label_eliminar_opcion_respuesta: "Delete Option Response",
            label_restaurar_opcion_respuesta: "Restore Option Response",
            label_mover_seccion_arriba: "Move Section Up",
            label_mover_seccion_abajo: "Move Section Down",
            label_descripcion: "Description",
            label_correo: "Email",
            label_subir_imagen: "Upload Image",
            label_subir_imagenes_de_tipo: "Upload Image of type .png or .jpg",
            label_las_imagenes_deben_ser_menor_a_512_kb: "The images must be less than 512 KB",
            label_motivo: "Motive",
            label_nivel_combustible: "Fuel Level",
            label_tipo: "Type",
            label_firma: "Signature",
            label_obligatorio: "Required",
            label_no_obligatorio: "Not Required",
            label_sub_tipo_usuario_web: "Sub Type User Web",
            label_telefono: "Phone",
            label_debe_ingresar_codigo_de_pais_telefono_sin_espacios: "Must enter country code + phone without spaces",
            label_ejemplo_59176691111: "Example: 19512619169",
            label_tipo_usuario_movil: "Type User Movil",
            label_opcion_respuesta: "Option Response",
            label_elegir_color: "Choose Color",
            label_enviar_correo_si_esta_opcion_es_seleccionada: "Send Email if this option is selected",
            label_tomar_foto_si_esta_opcion_es_seleccionada: "Take Photo if this option is selected",
            label_pedir_nota_de_descripcion_observacion: "Request Note of Description/Observation",
            label_pedir_fecha_si_esta_opcion_es_seleccionada: "Request Date if this option is selected",
            label_opcion_correcta_manejo_defensivo: "Correct Defensive Driving Option",
            label_formulario: "Form",
            label_pregunta: "Question",
            label_respuesta: "Answer",
            label_ver_imagen: "View Image",
            label_ver_foto_respuesta: "View Photo Response",
            label_pie_de_pagina: "Footer",
            label_pregunta_nro: "Question Nro",
            label_sin_contenido: "No Content",
            label_unidad: "Unit/Vehicle",
            label_apellido_paterno: "Last Name",
            label_apellido_materno: "Last Name",
            label_numero_lic_conducir: "License Number",
            label_acciones: "Actions",
            label_validar_odometro: "Validate Odometer",
            label_lista_correos: "List of Emails",
            label_nueva_contrasena: "New Password",
            label_ingrese_contrasena: "Enter New Password",
            label_riesgo: "Risk",
            label_inicio: "Start",
            label_fin: "End",
            label_multiple: "Multiple",
            label_no_multiple: "No Multiple",
            label_color: "Color",
            label_responsable_aprobar_riesgo: "Responsable to Approve Risk",
            label_persona_recibe_reporte: "Person who receives the report",
            label_otro: "Other",
            label_no_otro: "No Other",
            label_viaje: "Trip",
            label_orientacion_opciones_respuesta: "Orientation of Response Options",
            label_estado_viaje: "Trip Status",
            label_titulo_riesgo: "Risk Title",
            label_seleccione_estado_viaje: "Select Trip Status",
            label_ingrese_su_nombre: "Enter Your Name",
            label_persona_hizo_cambio_de_estado: "Person who made the state change",
            label_grupo: "Group",
            label_sub_grupo: "Sub Group",
            label_lista_unidades: "List of Units",

            alert_usuario_o_contrasena_incorrecto: "User or password incorrect",
            alert_debe_ingresar_usuario: "Must enter user",
            alert_debe_ingresar_password: "Must enter password",
            alert_debe_ingresar_confirmar_password: "Must enter confirm password",
            alert_passwords_no_coinciden: "Passwords do not match",
            alert_no_se_pudo_verificar_usuario: "Could not verify user",
            alert_usuario_ya_existe: "User already exists",
            alert_se_creo_correctamente: "Successfully created",
            alert_no_se_pudo_crear: "Could not create",
            alert_debe_ingresar_nombre: "Must enter name",
            alert_debe_ingresar_apellido_paterno: "Must enter last name",
            alert_url_copiada_al_portapapeles: "URL copied to clipboard",
            alert_procesado_correctamente: "Processed correctly",
            alert_no_se_pudo_procesar: "Could not process",
            alert_esta_seguro_de_deshabilitar_programacion_alerta: "Are you sure you want to disable the alert schedule?",
            alert_este_tipo_de_input_ya_existe: "This type of input already exists",
            alert_ocurrio_un_error_al_actualizar_la_lista_de_correos: "An error occurred while updating the list of emails",
            alert_ocurrio_un_error_al_actualizar_la_lista_de_telefonos: "An error occurred while updating the list of telephones",
            alert_nombre_es_requerido: "Name is required",
            alert_esta_seguro_de_deshabilitar_checklist: "Are you sure you want to disable the checklist?",
            alert_no_se_pudo_procesar_intente_nuevamente: "Could not process, try again",
            alert_confirma_deshabilitar_seccion_nro: "Confirm disable Section Nro: ",
            alert_confirma_deshabilitar_pregunta_nro: "Confirm disable Question Nro: ",
            alert_no_se_pudo_agregar_opcion_respuesta_intente_nuevamente: "Could not add option response, try again",
            alert_asegurese_que_su_opcion_respuesta_seleccionada_no_se_encuentre_en_opciones_respuesta_habilitadas_deshabilitadas: "Ensure that your selected response option is not in the enabled/disabled response options",
            alert_se_deshabilito_correctamente: "Disabled correctly",
            alert_no_se_pudo_deshabilitar_opcion_respuesta_intente_nuevamente: "Could not disable option response, try again",
            alert_confirma_deshabilitar_opcion_respuesta_nro: "Confirm disable Option Response: ",
            alert_confirma_restaurar_opcion_respuesta_nro: "Confirm restore Option Response: ",
            alert_se_restauro_correctamente: "Restored correctly",
            alert_no_se_pudo_restaurar_opcion_respuesta_intente_nuevamente: "Could not restore option response, try again",
            alert_esta_seguro_de_deshabilitar_respuesta_checklist: "Are you sure you want to disable Response Checklist?",
            alert_se_modifico_correctamente: "Modified correctly",
            alert_no_se_pudo_modificar: "Could not modify",
            alert_no_se_pudo_deshabilitar: "Could not disable",
            alert_esta_seguro_de_deshabilitar_correo: "Are you sure you want to disable Email?",
            alert_esta_seguro_de_deshabilitar_area: "Are you sure you want to disable Area?",
            alert_esta_seguro_de_deshabilitar_ciudad: "Are you sure you want to disable City?",
            alert_tamaño_de_archivo_excede_limite: "The file size exceeds the limit of 500 KB.",
            alert_esta_seguro_de_deshabilitar_icono: "Are you sure you want to disable Icon?",
            alert_se_elimino_correctamente: "Deleted correctly",
            alert_no_se_pudo_eliminar: "Could not delete",
            alert_se_selecciono_como_default_correctamente: "Selected as default correctly",
            alert_no_se_pudo_realizar_el_cambio: "Could not perform the change",
            alert_esta_seguro_de_eliminar_imagen: "Are you sure you want to delete the image?",
            alert_esta_seguro_de_seleccionar_como_imagen_principal_default: "Are you sure you want to select as image principal/default?",
            alert_esta_seguro_de_quitar_imagen_principal_default: "Are you sure you want to remove the image principal/default?",
            alert_debe_importar_imagen: "Must import image",
            alert_se_guardo_correctamente: "Saved correctly",
            alert_no_se_pudo_guardar_imagen: "Could not save image, please review that the resolution is not greater than 566x360",
            alert_formato_de_archivo_no_valido: "Invalid file format. Please select a .jpg or .png file.",
            alert_esta_seguro_de_deshabilitar_marca_vehiculo: "Are you sure you want to disable Vehicle Brand?",
            alert_esta_seguro_de_deshabilitar_motivo: "Are you sure you want to disable Motive?",
            alert_esta_seguro_de_deshabilitar_nivel_combustible: "Are you sure you want to disable Fuel Level?",
            alert_esta_seguro_de_deshabilitar_formulario: "Are you sure you want to disable Form?",
            alert_no_se_pudo_agregar_nuevo_input: "Could not add new input",
            alert_no_se_pudo_actualizar_todos_los_inputs_intente_nuevamente: "Could not update all inputs, try again",
            alert_se_actualizo_correctamente: "Updated correctly",
            alert_esta_seguro_de_deshabilitar_sub_tipo_usuario_web: "Are you sure you want to disable Sub Type User Web?",
            alert_esta_seguro_de_deshabilitar_telefono: "Are you sure you want to disable Phone?",
            alert_esta_seguro_de_deshabilitar_tipo_carroceria: "Are you sure you want to disable Vehicle Body Type?",
            alert_esta_seguro_de_deshabilitar_tipo_combustible: "Are you sure you want to disable Fuel Type?",
            alert_esta_seguro_de_deshabilitar_tipo_usuario_movil: "Are you sure you want to disable Type User Movil?",
            alert_esta_seguro_de_deshabilitar_tipo_vehiculo: "Are you sure you want to disable Vehicle Type?",
            alert_esta_seguro_de_deshabilitar_opcion_respuesta: "Are you sure you want to disable Option Response?",
            alert_esta_seguro_de_deshabilitar_tipo_checklist: "Are you sure you want to disable Type Checklist?",
            alert_debe_seleccionar_tipo_checklist: "Must select type checklist",
            alert_debe_seleccionar_unidad: "Must select unit/vehicle",
            alert_debe_seleccionar_fechas_validas: "Must select valid dates",
            alert_esta_seguro_de_deshabilitar_usuario: "Are you sure you want to disable User?",
            alert_esta_seguro_de_habilitar_usuario: "Are you sure you want to enable User?",
            alert_se_proceso_correctamente: "Processed correctly",
            alert_procesando_solicitud: "Processing request...",
            alert_esta_seguro_de_deshabilitar: "Are you sure you want to disable?",
            alert_debe_ingresar_contrasena_de_5_caracteres_minimo: "Must enter password of minimum 5 characters",
            alert_debe_ingresar_descripcion: "Must enter description",
            alert_se_cambio_estado_viaje_correctamente: "Trip status changed successfully",
            alert_debe_ingresar_datos: "Must enter data",

            menu_dashboard: "Dashboard",
            menu_usuarios: "Users",
            menu_usuarios_web: "Users Web",
            menu_usuarios_movil: "Users Movil",
            menu_configuracion: "Configuration",
            menu_reportes: "Reports",
            menu_salir: "Logout",
            menu_mis_checklist: "My Checklist",
            menu_respuestas_checklist: "Responses Checklist",
            menu_permisos: "Permissions",
            menu_administracion: "Administration",
            menu_personal_transportar: "Crew Transport",
            menu_ruta: "Route",
            menu_persona: "Person",
            menu_riesgo: "Risk",
            menu_turno: "Shift",
            menu_estado_viaje: "Trip Status",

            titulo_opciones_respuesta_seleccionadas: "Selected Response Options",
            titulo_vehiculos_sin_checklist: "Vehicles Without Checklist",
            titulo_vehiculos_con_checklist: "Vehicles With Checklist",
            titulo_sin_checklist: "Without Checklist",
            titulo_con_checklist: "With Checklist",
            titulo_vehiculos_que_realizaron_checklist: "Vehicles That Performed Checklist",
            titulo_exportar_grafico: "Export Graph",
            titulo_detalle_checklist: "Details of Checklist",
            titulo_respuestas_checklist: "Responses Checklist",
            titulo_alertas_checklist: "Checklist Alerts",
            titulo_alertas: "Alerts",
            titulo_formulario_checklist: "Checklist Form",
            titulo_gestionar_mis_checklist: "Manage My Checklist",
            titulo_eliminar_seccion: "Delete Section",
            titulo_firma: "Signature",
            titulo_imagen: "Image",
            titulo_comentario: "Comment",
            titulo_preguntas_checklist: "Questions Checklist",
            titulo_guardar_preguntas: "Save Questions",
            titulo_detalle_respuestas_checklist: "Details of Response Checklist",
            titulo_lista_respuestas_checklist: "List of Responses Checklist",
            titulo_modificar_correo: "Modify Email",
            titulo_crear_correo: "Create Email",
            titulo_gestionar_correos: "Manage Emails",
            titulo_modificar_area: "Modify Area",
            titulo_crear_area: "Create Area",
            titulo_gestionar_area: "Manage Area",
            titulo_ciudad: "City",
            titulo_modificar_ciudad: "Modify City",
            titulo_crear_ciudad: "Create City",
            titulo_gestionar_ciudad: "Manage City",
            titulo_agregar_icono: "Add Icon",
            titulo_gestionar_iconos: "Manage Icons",
            titulo_nuevo_logo: "New Logo",
            titulo_gestionar_logo: "Manage Logo",
            titulo_modificar_marca_vehiculo: "Modify Vehicle Brand",
            titulo_crear_marca_vehiculo: "Create Vehicle Brand",
            titulo_gestionar_marca_vehiculo: "Manage Vehicle Brand",
            titulo_modificar_motivo: "Modify Motive",
            titulo_crear_motivo: "Create Motive",
            titulo_gestionar_motivo: "Manage Motive",
            titulo_modificar_nivel_combustible: "Modify Fuel Level",
            titulo_crear_nivel_combustible: "Create Fuel Level",
            titulo_gestionar_nivel_combustible: "Manage Fuel Level",
            titulo_modificar_formulario_pie_de_pagina: "Modify Form Footer",
            titulo_gestionar_pie_de_pagina: "Manage Footer",
            titulo_nuevo_pie_de_pagina: "New Footer",
            titulo_modificar_sub_tipo_usuario_web: "Modify Sub Type User Web",
            titulo_crear_sub_tipo_usuario_web: "Create Sub Type User Web",
            titulo_gestionar_sub_tipo_usuario_web: "Manage Sub Type User Web",
            titulo_modificar_telefono: "Modify Phone",
            titulo_crear_telefono: "Create Phone",
            titulo_gestionar_telefono: "Manage Phone",
            titulo_modificar_tipo_carroceria: "Modify Vehicle Body Type",
            titulo_crear_tipo_carroceria: "Create Vehicle Body Type",
            titulo_gestionar_tipo_carroceria: "Manage Vehicle Body Type",
            titulo_modificar_tipo_combustible: "Modify Fuel Type",
            titulo_crear_tipo_combustible: "Create Fuel Type",
            titulo_gestionar_tipo_combustible: "Manage Fuel Type",
            titulo_modificar_tipo_usuario_movil: "Modify Type User Movil",
            titulo_crear_tipo_usuario_movil: "Create Type User Movil",
            titulo_gestionar_tipo_usuario_movil: "Manage Type User Movil",
            titulo_modificar_tipo_vehiculo: "Modify Vehicle Type",
            titulo_crear_tipo_vehiculo: "Create Vehicle Type",
            titulo_gestionar_tipo_vehiculo: "Manage Vehicle Type",
            titulo_modificar_opcion_respuesta: "Modify Option Response",
            titulo_crear_opcion_respuesta: "Create Option Response",
            titulo_gestionar_opcion_respuesta: "Manage Option Response",
            titulo_modificar_tipo_checklist: "Modify Type Checklist",
            titulo_crear_tipo_checklist: "Create Type Checklist",
            titulo_gestionar_tipo_checklist: "Manage Type Checklist",
            titulo_crear_checklist: "Create Checklist",
            titulo_consolidado_respuestas_checklist: "Consolidated Responses Checklist",
            titulo_modificar_usuario_movil: "Modify User Movil",
            titulo_crear_usuario_movil: "Create User Movil",
            titulo_lista_usuario_movil: "List of User Movil",
            titulo_modificar_usuario_web: "Modify User Web",
            titulo_crear_usuario_web: "Create User Web",
            titulo_lista_usuario_web: "List of User Web",
            titulo_permisos_sub_tipo_usuario_web: "Permissions - Web User Subtype",
            titulo_gestionar_alerta_opcion_respuesta_placa: "Manage Alert Option Response - Plate",
            titulo_crear_alerta_opcion_respuesta_placa: "Create Alert Option Response - Plate",
            titulo_modificar_alerta_opcion_respuesta_placa: "Modify Alert Option Response - Plate",
            titulo_gestionar_personal_transportar: "Manage Personal Transportar",
            titulo_crear_personal_transportar: "Create Personal Transportar",
            titulo_modificar_personal_transportar: "Modify Personal Transportar",
            titulo_crear_ruta: "Create Route",
            titulo_modificar_ruta: "Modify Route",
            titulo_crear_persona: "Create Person",
            titulo_modificar_persona: "Modify Person",
            titulo_crear_riesgo: "Create Risk",
            titulo_modificar_riesgo: "Modify Risk",
            titulo_gestionar_ruta: "Manage Route",
            titulo_gestionar_persona: "Manage Person",
            titulo_gestionar_riesgo: "Manage Risk",
            titulo_gestionar_turno: "Manage Shift",
            titulo_crear_turno: "Create Shift",
            titulo_modificar_turno: "Modify Shift",
            titulo_viaje_checklist: "Trip",
            titulo_gestionar_estado_viaje: "Manage Trip Status",
            titulo_crear_estado_viaje: "Create Trip Status",
            titulo_modificar_estado_viaje: "Modify Trip Status",

            btn_buscar: "Search",
            btn_atras: "Back",
            btn_exportar: "Export",
            btn_exportar_excel: "Export Excel",
            btn_imprimir: "Print",
            btn_deshabilitar: "Disable",
            btn_cancelar: "Cancel",
            btn_aceptar: "Accept",
            btn_agregar: "Add",
            btn_modificar: "Modify",
            btn_formulario: "Form",
            btn_alertas: "Alerts",
            btn_actualizar: "Update",
            btn_nueva_seccion: "New Section",
            btn_guardar_preguntas: "Save Questions",
            btn_ver: "View",
            btn_nuevo: "New",
            btn_eliminar_imagen: "Delete Image",
            btn_set_default: "Set Default",
            btn_remove_default: "Remove Default",
            btn_guardar: "Save",
            btn_eliminar_pregunta: "Delete Question",
            btn_confirmar: "Confirm",
            btn_crear: "Create",
            btn_cerrar: "Close",
            btn_habilitar: "Enable",
            btn_permisos: "Permissions",
            btn_compartir: "Share",
            btn_restaurar: "Restore",
            btn_exportar_pdf: "Export PDF",
            btn_viaje: "Trip",
            btn_make_default: "Make Default",
            btn_make_un_default: "Make Un Default",

            header_pregunta: "Question",
            header_respuesta: "Answer",

            column_vehiculo: "VEHICLE",
            column_acciones: "ACTIONS",
            column_nombre: "NAME",
            column_tipo_checklist: "CHECKLIST TYPE",
            column_manejo_defensivo: "DEFENSIVE DRIVING",
            column_nota: "NOTE",
            column_nombre_checklist: "CHECKLIST NAME",
            column_odometro_actual: "CURRENT ODOMETER",
            column_odometro_proximo: "NEXT ODOMETER",
            column_fecha_actual_checklist: "CURRENT CHECKLIST DATE",
            column_fecha_proximo_checklist: "NEXT CHECKLIST DATE",
            column_conductor: "DRIVER",
            column_nombre_area: "NAME AREA",
            column_ciudad: "CITY",
            column_tipo_vehiculo: "VEHICLE TYPE",
            column_marca_vehiculo: "VEHICLE BRAND",
            column_tipo_carroceria: "VEHICLE BODY TYPE",
            column_tipo_combustible: "FUEL TYPE",
            column_fecha_proceso: "PROCESS DATE",
            column_descripcion: "DESCRIPTION",
            column_correo: "EMAIL",
            column_url: "URL",
            column_telefono: "TELEFONO",
            column_enviar_correo: "SEND EMAIL",
            column_tomar_foto: "TAKE PHOTO",
            column_nota_observacion: "NOTE/OBSERVATION",
            column_pedir_fecha: "REQUEST DATE",
            column_critico: "CRITICAL",
            column_correos: "EMAILS",
            column_tipo_usuario: "TYPE USER",
            column_apellido_paterno: "LAST NAME",
            column_apellido_materno: "LAST NAME",
            column_num_lic_conducir: "NUM LIC CONDUCIR",
            column_usuario: "USER",
            column_contrasena: "PASSWORD",
            column_unidad: "UNIT/VEHICLE",
            column_apellido: "LAST NAME",
            column_sub_tipo_usuario_web: "SUB TYPE USER WEB",
            column_opcion_respuesta: "OPTION RESPONSE",
            column_placa: "VEHICLE PLATE",
            column_lista_correos: "LIST OF EMAILS",
            column_codigo: "CODIGO",
            column_inicio: "START",
            column_fin: "END",
            column_responsables: "SUPERVISORS",
            column_color: "COLOR",
            column_viaje: "TRIP",

            select_seleccionar_unidad: "SELECT UNIT/VEHICLE",
            select_input_odometro_actual: "INPUT CURRENT ODOMETER",
            select_input_odometro_proximo_checklist: "INPUT NEXT ODOMETER CHECKLIST",
            select_fecha_actual_checklist: "CURRENT CHECKLIST DATE",
            select_fecha_proximo_checklist: "NEXT CHECKLIST DATE",
            select_seleccionar_conductor: "SELECT DRIVER",
            select_seleccionar_area: "SELECT AREA",
            select_seleccionar_tipo_checklist: "SELECT CHECKLIST TYPE",
            select_seleccionar_tipo_vehiculo: "SELECT VEHICLE TYPE",
            select_seleccionar_marca_vehiculo: "SELECT VEHICLE BRAND",
            select_seleccionar_tipo_carroceria: "SELECT VEHICLE BODY TYPE",
            select_seleccionar_tipo_combustible: "SELECT FUEL TYPE",
            select_seleccionar_ciudad: "SELECT CITY",
            select_ultimo_odometro_registrado: "LAST ODOMETER REGISTERED",
            select_ultima_temperatura_registrada: "LAST TEMPERATURE REGISTERED",
            select_seleccionar_nivel_combustible: "SELECT FUEL LEVEL",
            select_seleccionar_motivo: "SELECT MOTIVE/REASON",
            select_input_numero_de_conocimiento: "INPUT NUMBER OF KNOWLEDGE",
            select_seleccionar_estado: "SELECT STATUS",
            select_seleccione_tipo_usuario: "SELECT TYPE USER",
            select_seleccione_unidad: "SELECT UNIT/VEHICLE",
            select_seleccione_sub_tipo_usuario: "SELECT SUB TYPE USER",
            select_geocerca_origen: "SELECT GEOFENCE ORIGIN",
            select_geocerca_destino: "SELECT GEOFENCE DESTINATION",
            select_seleccionar_personal_transportar: "SELECT CREW TRANSPORTER",
            select_ruta: "SELECT ROUTE",
            select_turno: "SELECT SHIFT",
            select_input_ruta: "INPUT ROUTE",
            select_input_actividad: "INPUT ACTIVITY",
            select_ida_vuelta_el_mismo_dia: "SELECT ROUND TRIP SAME DAY",
            input_fecha_hora_partida: "INPUT DATE AND TIME OF DEPARTURE",
            input_fecha_hora_llegada: "INPUT DATE AND TIME OF ARRIVAL",
            input_total_kilometros: "INPUT TOTAL KILOMETERS",
            input_contacto_destino: "INPUT CONTACT DESTINATION",
            input_proposito_del_viaje: "INPUT PURPOSE OF JOURNEY",
            input_telefono: "INPUT PHONE",
            input_empresa: "INPUT COMPANY",
            input_type: "INPUT TYPE",
            input_propietario: "INPUT OWNER",

            input_fecha_programada_de_viaje: "INPUT SCHEDULED DATE OF JOURNEY",
            input_odometro_proximo_mantenimiento: "INPUT NEXT ODOMETER MAINTENANCE",

            placeholder_ingresa_descripcion: "Enter Description",
            placeholder_ingresa_inicio: "Enter Start",
            placeholder_ingresa_fin: "Enter End",
            placeholder_ingresa_nota: "Enter Note",
            placeholder_ingresa_codigo: "Enter Code",
            placeholder_seleccione_correo: "Select Email",
            placeholder_seleccione_personas: "Select Supervisors",
            placeholder_seleccione_persona_recibe_reporte: "Select Person who receives the report",
            placeholder_seleccione_responsable_aprobar_riesgo: "Select Responsible to Approve Risk",
            placeholder_seleccione_estado_viaje: "Select Trip Status",
            placeholder_ingrese_su_nombre: "Enter Your Name",
            placeholder_select_seleccione_grupo: "Select Group",
            placeholder_select_seleccione_sub_grupo: "Select Sub Group",
            placeholder_select_seleccione_unidades: "Select Vehicles",

            select_seleccionar_ruta: "SELECT ROUTE",
            input_hora_de_paso: "INPUT HOUR OF PASS",
            input_kilometro: "INPUT KILOMETRE",
            input_tiempo_descanso: "INPUT TIME OF REST",
            select_reportar_ubicacion: "SELECT REPORT LOCATION",
            input_observacion: "INPUT OBSERVATION",
        },
    },
    es: {
        translation: {
            label_idioma: "Idioma",
            label_plataforma_checklist: "Plataforma de Checklist",
            label_usuario: "Usuario",
            label_contrasena: "Contraseña",
            label_ingresar: "Ingresar",
            label_registrarse: "Registrarse",
            label_registrar_usuario: "Registrar Usuario",
            label_nombre: "Nombre",
            label_apellido: "Apellido",
            label_nota: "Nota",
            label_siguiente: "Siguiente",
            label_atras: "Atrás",
            label_crear_cuenta: "Crear Cuenta",
            label_password: "Contraseña",
            label_confirmar_password: "Confirmar Contraseña",
            label_ver_detalles: "Ver Detalles",
            label_vehiculo: "Vehículo",
            label_fecha_registro: "Fecha Registro",
            label_secciones: "Secciones",
            label_critico: "Crítico",
            label_seleccione_unidad: "Seleccione Vehículo",
            label_fecha_inicio: "Fecha Inicio",
            label_fecha_fin: "Fecha Fin",
            label_cantidad: "Cantidad",
            label_total_critico: "Total Crítico",
            label_si: "Sí",
            label_no: "No",
            label_codigo: "Código",
            label_enviar_correo: "Enviar Correo",
            label_seleccione_correos: "Seleccione Correos",
            label_enviar_mensaje_via_whatsapp: "Enviar Mensaje via WhatsApp",
            label_seleccione_telefonos: "Seleccione Telefonos",
            label_validar_conductor: "Validar Conductor",
            label_activo: "Activo",
            label_no_activo: "No Activo",
            label_tipo_input: "Tipo Input",
            label_ejemplo: "Ejemplo",
            label_mover_input_arriba: "Mover Input Arriba",
            label_mover_input_abajo: "Mover Input Abajo",
            label_seleccione_input: "Seleccione Input",
            label_datos_extra_requeridos: "Datos Extra Requeridos",
            label_respuesta_checklist: "Respuesta Checklist",
            label_nombre_checklist: "Nombre Checklist",
            label_tipo_checklist: "Tipo Checklist",
            label_area: "Área",
            label_ciudad: "Ciudad",
            label_tipo_vehiculo: "Tipo Vehículo",
            label_marca_vehiculo: "Marca Vehículo",
            label_tipo_carroceria: "Tipo Carroceria",
            label_tipo_combustible: "Tipo Combustible",
            label_nombre_seccion: "Nombre Sección",
            label_preguntas: "Preguntas",
            label_seccion_nro: "Número Sección",
            label_manejo_defensivo: "Manejo Defensivo",
            label_opciones_respuesta_habilitadas: "Opciones Respuesta Habilitadas",
            label_opciones_respuesta_deshabilitadas: "Opciones Respuesta Deshabilitadas",
            label_tipo_pregunta: "Tipo Pregunta",
            label_mover_arriba: "Mover Arriba",
            label_mover_abajo: "Mover Abajo",
            label_no_tiene_nombre_seccion: "NO TIENE NOMBRE SECCION",
            label_numero_pregunta: "Número Pregunta",
            label_no_tiene_titulo_pregunta_descripcion: "NO TIENE TITULO PREGUNTA/DESCRIPCION",
            label_no_tiene_opciones_respuesta: "NO TIENE OPCIONES RESPUESTA",
            label_seleccione_tipo_checklist: "Seleccione Tipo Checklist",
            label_seccion: "Sección",
            label_eliminar_opcion_respuesta: "Eliminar Opción Respuesta",
            label_restaurar_opcion_respuesta: "Restaurar Opción Respuesta",
            label_mover_seccion_arriba: "Mover Sección Arriba",
            label_mover_seccion_abajo: "Mover Sección Abajo",
            label_descripcion: "Descripción",
            label_correo: "Correo",
            label_subir_imagen: "Subir Imagen",
            label_subir_imagenes_de_tipo: "Subir Imagen de tipo .png o .jpg",
            label_las_imagenes_deben_ser_menor_a_512_kb: "Las imagenes deben ser menor a 512 KB",
            label_motivo: "Motivo",
            label_nivel_combustible: "Nivel Combustible",
            label_tipo: "Tipo",
            label_firma: "Firma",
            label_obligatorio: "Obligatorio",
            label_no_obligatorio: "No Obligatorio",
            label_sub_tipo_usuario_web: "Sub Tipo Usuario Web",
            label_telefono: "Teléfono",
            label_debe_ingresar_codigo_de_pais_telefono_sin_espacios: "Debe ingresar codigo de pais + telefono sin espacios",
            label_ejemplo_59176691111: "Ejemplo: 59176691111",
            label_tipo_usuario_movil: "Tipo Usuario Movil",
            label_opcion_respuesta: "Opción Respuesta",
            label_elegir_color: "Elegir Color",
            label_enviar_correo_si_esta_opcion_es_seleccionada: "Enviar Correo si esta opción es seleccionada",
            label_tomar_foto_si_esta_opcion_es_seleccionada: "Tomar Foto si esta opción es seleccionada",
            label_pedir_nota_de_descripcion_observacion: "Pedir Nota Descripción/Observación",
            label_pedir_fecha_si_esta_opcion_es_seleccionada: "Pedir Fecha se esta opción es seleccionada",
            label_opcion_correcta_manejo_defensivo: "Opción Correcta Manejo Defensivo",
            label_formulario: "Formulario",
            label_pregunta: "Pregunta",
            label_respuesta: "Respuesta",
            label_ver_imagen: "Ver Imagen",
            label_ver_foto_respuesta: "Ver Foto Respuesta",
            label_pie_de_pagina: "Pie de Página",
            label_pregunta_nro: "Pregunta Nro",
            label_sin_contenido: "Sin Contenido",
            label_unidad: "Unidad",
            label_apellido_paterno: "Apellido Paterno",
            label_apellido_materno: "Apellido Materno",
            label_numero_lic_conducir: "Número Licencia Conducir",
            label_acciones: "Acciones",
            label_validar_odometro: "Validar Odometro",
            label_lista_correos: "Lista Correos",
            label_nueva_contrasena: "Nueva Contraseña",
            label_ingrese_contrasena: "Ingrese nueva contraseña",
            label_riesgo: "Riesgo",
            label_inicio: "Inicio",
            label_fin: "Fin",
            label_multiple: "Multiple",
            label_no_multiple: "No Multiple",
            label_color: "Color",
            label_responsable_aprobar_riesgo: "Responsable Aprobar Riesgo",
            label_persona_recibe_reporte: "Persona que recibe el reporte",
            label_otro: "Otro",
            label_no_otro: "No Otro",
            label_viaje: "Viaje",
            label_orientacion_opciones_respuesta: "Orientación de Opciones Respuesta",
            label_estado_viaje: "Estado Viaje",
            label_titulo_riesgo: "Titulo Riesgo",
            label_seleccione_estado_viaje: "Seleccione Estado Viaje",
            label_ingrese_su_nombre: "Ingrese Su Nombre",
            label_persona_hizo_cambio_de_estado: "Persona que hizo el cambio de estado",
            label_grupo: "Grupo",
            label_sub_grupo: "SubGrupo",
            label_lista_unidades: "Lista Unidades",

            alert_ocurrio_un_error_al_actualizar_la_lista_de_correos: "Ocurrio un error al actualizar la lista de correos",
            alert_ocurrio_un_error_al_actualizar_la_lista_de_telefonos: "Ocurrio un error al actualizar la lista de telefonos",
            alert_usuario_o_contrasena_incorrecto: "Usuario o contraseña incorrecto",
            alert_debe_ingresar_usuario: "Debe ingresar usuario",
            alert_debe_ingresar_password: "Debe ingresar contraseña",
            alert_debe_ingresar_confirmar_password: "Debe ingresar confirmar contraseña",
            alert_passwords_no_coinciden: "Las contraseñas no coinciden",
            alert_no_se_pudo_verificar_usuario: "No se pudo verificar el usuario",
            alert_usuario_ya_existe: "Usuario ya existe",
            alert_se_creo_correctamente: "Se creó correctamente",
            alert_no_se_pudo_crear: "No se pudo crear",
            alert_debe_ingresar_nombre: "Debe ingresar nombre",
            alert_debe_ingresar_apellido_paterno: "Debe ingresar apellido",
            alert_url_copiada_al_portapapeles: "URL copiada para el portapapeles",
            alert_procesado_correctamente: "Procesado correctamente",
            alert_no_se_pudo_procesar: "No se pudo procesar",
            alert_esta_seguro_de_deshabilitar_programacion_alerta: "¿Está seguro de deshabilitar la programación de alerta?",
            alert_este_tipo_de_input_ya_existe: "Este tipo de input ya existe",
            alert_nombre_es_requerido: "Nombre es requerido",
            alert_esta_seguro_de_deshabilitar_checklist: "¿Está seguro de deshabilitar el checklist?",
            alert_no_se_pudo_procesar_intente_nuevamente: "No se pudo procesar, intente nuevamente",
            alert_confirma_deshabilitar_seccion_nro: "Confirma deshabilitar Sección Nro: ",
            alert_confirma_deshabilitar_pregunta_nro: "Confirma deshabilitar Pregunta Nro: ",
            alert_no_se_pudo_agregar_opcion_respuesta_intente_nuevamente: "No se pudo agregar opción respuesta, intente nuevamente",
            alert_asegurese_que_su_opcion_respuesta_seleccionada_no_se_encuentre_en_opciones_respuesta_habilitadas_deshabilitadas: "Asegurese que su OPCION RESPUESTA SELECCIONADA no se encuentre en Opciones Respuesta Habilitadas/Deshabilitadas",
            alert_se_deshabilito_correctamente: "Se deshabilitó correctamente",
            alert_no_se_pudo_deshabilitar_opcion_respuesta_intente_nuevamente: "No se pudo deshabilitar opción respuesta, intente nuevamente",
            alert_confirma_deshabilitar_opcion_respuesta_nro: "Confirma deshabilitar Opción Respuesta: ",
            alert_confirma_restaurar_opcion_respuesta_nro: "Confirma restaurar Opción Respuesta: ",
            alert_se_restauro_correctamente: "Se restauró correctamente",
            alert_no_se_pudo_restaurar_opcion_respuesta_intente_nuevamente: "No se pudo restaurar opción respuesta, intente nuevamente",
            alert_esta_seguro_de_deshabilitar_respuesta_checklist: "¿Está seguro de deshabilitar Respuesta Checklist?",
            alert_se_modifico_correctamente: "Se modificó correctamente",
            alert_no_se_pudo_modificar: "No se pudo modificar",
            alert_no_se_pudo_deshabilitar: "No se pudo deshabilitar",
            alert_esta_seguro_de_deshabilitar_correo: "¿Está seguro de deshabilitar Correo?",
            alert_esta_seguro_de_deshabilitar_area: "¿Está seguro de deshabilitar Area?",
            alert_esta_seguro_de_deshabilitar_ciudad: "¿Está seguro de deshabilitar Ciudad?",
            alert_tamaño_de_archivo_excede_limite: "El tamaño del archivo excede el límite de 500 KB.",
            alert_esta_seguro_de_deshabilitar_icono: "¿Está seguro de deshabilitar Icono?",
            alert_se_elimino_correctamente: "Se eliminó correctamente",
            alert_no_se_pudo_eliminar: "No se pudo eliminar",
            alert_se_selecciono_como_default_correctamente: "Se seleccionó como default correctamente",
            alert_no_se_pudo_realizar_el_cambio: "No se pudo realizar el cambio",
            alert_esta_seguro_de_eliminar_imagen: "¿Está seguro de eliminar Imagen?",
            alert_esta_seguro_de_seleccionar_como_imagen_principal_default: "¿Está seguro de seleccionar como imagen Principal/Default?",
            alert_esta_seguro_de_quitar_imagen_principal_default: "¿Está seguro de quitar imagen Principal/Default?",
            alert_debe_importar_imagen: "Debe importar imagen",
            alert_se_guardo_correctamente: "Se guardó correctamente",
            alert_no_se_pudo_guardar_imagen: "No se pudo guardar imagen, por favor revise que la resolucion no sea mayor a 566x360",
            alert_formato_de_archivo_no_valido: "Formato de archivo no válido. Por favor, selecciona un archivo .jpg o .png.",
            alert_esta_seguro_de_deshabilitar_marca_vehiculo: "¿Está seguro de deshabilitar Marca Vehículo?",
            alert_esta_seguro_de_deshabilitar_motivo: "¿Está seguro de deshabilitar Motivo?",
            alert_esta_seguro_de_deshabilitar_nivel_combustible: "¿Está seguro de deshabilitar Nivel Combustible?",
            alert_esta_seguro_de_deshabilitar_formulario: "¿Está seguro de deshabilitar Formulario?",
            alert_no_se_pudo_agregar_nuevo_input: "No se pudo agregar nuevo input",
            alert_no_se_pudo_actualizar_todos_los_inputs_intente_nuevamente: "No se pudo actualizar todos los inputs, intente nuevamente",
            alert_se_actualizo_correctamente: "Se actualizo correctamente",
            alert_esta_seguro_de_deshabilitar_sub_tipo_usuario_web: "¿Está seguro de deshabilitar Sub Tipo Usuario Web?",
            alert_esta_seguro_de_deshabilitar_telefono: "¿Está seguro de deshabilitar Telefono?",
            alert_esta_seguro_de_deshabilitar_tipo_carroceria: "¿Está seguro de deshabilitar Tipo Carroceria?",
            alert_esta_seguro_de_deshabilitar_tipo_combustible: "¿Está seguro de deshabilitar Tipo Combustible?",
            alert_esta_seguro_de_deshabilitar_tipo_usuario_movil: "¿Está seguro de deshabilitar Tipo Usuario Movil?",
            alert_esta_seguro_de_deshabilitar_tipo_vehiculo: "¿Está seguro de deshabilitar Tipo Vehículo?",
            alert_esta_seguro_de_deshabilitar_opcion_respuesta: "¿Está seguro de deshabilitar Opción Respuesta?",
            alert_esta_seguro_de_deshabilitar_tipo_checklist: "¿Está seguro de deshabilitar Tipo Checklist?",
            alert_debe_seleccionar_tipo_checklist: "Debe seleccionar tipo checklist",
            alert_debe_seleccionar_unidad: "Debe seleccionar unidad/vehículo",
            alert_debe_seleccionar_fechas_validas: "Debe seleccionar fechas válidas",
            alert_esta_seguro_de_deshabilitar_usuario: "¿Está seguro de deshabilitar Usuario?",
            alert_esta_seguro_de_habilitar_usuario: "¿Está seguro de habilitar Usuario?",
            alert_se_proceso_correctamente: "Se proceso correctamente",
            alert_procesando_solicitud: "Procesando solicitud...",
            alert_esta_seguro_de_deshabilitar: "¿Está seguro de deshabilitar?",
            alert_debe_ingresar_contrasena_de_5_caracteres_minimo: "Debe ingresar 5 caracteres como minimo",
            alert_debe_ingresar_descripcion: "Debe ingresar descripción",
            alert_se_cambio_estado_viaje_correctamente: "Se cambió estado viaje correctamente",
            alert_debe_ingresar_datos: "Debe ingresar datos",

            menu_dashboard: "Dashboard",
            menu_usuarios: "Usuarios",
            menu_usuarios_web: "Usuarios Web",
            menu_usuarios_movil: "Usuarios Movil",
            menu_configuracion: "Configuración",
            menu_reportes: "Reportes",
            menu_salir: "Salir",
            menu_mis_checklist: "Mis Checklist",
            menu_respuestas_checklist: "Respuestas Checklist",
            menu_permisos: "Permisos",
            menu_administracion: "Administración",
            menu_personal_transportar: "Personal Transportar",
            menu_ruta: "Ruta",
            menu_persona: "Persona",
            menu_riesgo: "Riesgo",
            menu_turno: "Turno",
            menu_estado_viaje: "Estado Viaje",

            titulo_opciones_respuesta_seleccionadas: "Opciones Respuesta Seleccionadas",
            titulo_vehiculos_sin_checklist: "Vehículos Sin Checklist",
            titulo_vehiculos_con_checklist: "Vehículos Con Checklist",
            titulo_sin_checklist: "Sin Checklist",
            titulo_con_checklist: "Con Checklist",
            titulo_vehiculos_que_realizaron_checklist: "Vehículos Que Realizaron Checklist",
            titulo_exportar_grafico: "Exportar Gráfico",
            titulo_detalle_checklist: "Detalles del Checklist",
            titulo_respuestas_checklist: "Respuestas Checklist",
            titulo_alertas_checklist: "Alertas Checklist",
            titulo_alertas: "Alertas",
            titulo_formulario_checklist: "Formulário Checklist",
            titulo_gestionar_mis_checklist: "Gestionar Mis Checklist",
            titulo_eliminar_seccion: "Eliminar Sección",
            titulo_firma: "Firma",
            titulo_imagen: "Imagen",
            titulo_comentario: "Comentario",
            titulo_preguntas_checklist: "Preguntas Checklist",
            titulo_guardar_preguntas: "Guardar Preguntas",
            titulo_detalle_respuestas_checklist: "Detalles de Respuesta Checklist",
            titulo_lista_respuestas_checklist: "Lista Respuestas Checklist",
            titulo_modificar_correo: "Modificar Correo",
            titulo_crear_correo: "Crear Correo",
            titulo_gestionar_correos: "Gestionar Correos",
            titulo_modificar_area: "Modificar Area",
            titulo_crear_area: "Crear Area",
            titulo_gestionar_area: "Gestionar Area",
            titulo_ciudad: "Ciudad",
            titulo_modificar_ciudad: "Modificar Ciudad",
            titulo_crear_ciudad: "Crear Ciudad",
            titulo_gestionar_ciudad: "Gestionar Ciudad",
            titulo_agregar_icono: "Add Icon",
            titulo_gestionar_iconos: "Gestionar Iconos",
            titulo_nuevo_logo: "Nuevo Logo",
            titulo_gestionar_logo: "Gestionar Logo",
            titulo_modificar_marca_vehiculo: "Modificar Marca Vehículo",
            titulo_crear_marca_vehiculo: "Crear Marca Vehículo",
            titulo_gestionar_marca_vehiculo: "Gestionar Marca Vehículo",
            titulo_modificar_motivo: "Modificar Motivo",
            titulo_crear_motivo: "Crear Motivo",
            titulo_gestionar_motivo: "Gestionar Motivo",
            titulo_modificar_nivel_combustible: "Modificar Nivel Combustible",
            titulo_crear_nivel_combustible: "Crear Nivel Combustible",
            titulo_gestionar_nivel_combustible: "Gestionar Nivel Combustible",
            titulo_modificar_formulario_pie_de_pagina: "Modificar Formulario Pie de Pagina",
            titulo_gestionar_pie_de_pagina: "Gestionar Pie de Pagina",
            titulo_nuevo_pie_de_pagina: "Nuevo Pie de Pagina",
            titulo_modificar_sub_tipo_usuario_web: "Modificar Sub Tipo Usuario Web",
            titulo_crear_sub_tipo_usuario_web: "Crear Sub Tipo Usuario Web",
            titulo_gestionar_sub_tipo_usuario_web: "Gestionar Sub Tipo Usuario Web",
            titulo_modificar_telefono: "Modificar Telefono",
            titulo_crear_telefono: "Crear Telefono",
            titulo_gestionar_telefono: "Gestionar Telefono",
            titulo_modificar_tipo_carroceria: "Modificar Tipo Carroceria",
            titulo_crear_tipo_carroceria: "Crear Tipo Carroceria",
            titulo_gestionar_tipo_carroceria: "Gestionar Tipo Carroceria",
            titulo_modificar_tipo_combustible: "Modificar Tipo Combustible",
            titulo_crear_tipo_combustible: "Crear Tipo Combustible",
            titulo_gestionar_tipo_combustible: "Gestionar Tipo Combustible",
            titulo_modificar_tipo_usuario_movil: "Modificar Tipo Usuario Movil",
            titulo_crear_tipo_usuario_movil: "Crear Tipo Usuario Movil",
            titulo_gestionar_tipo_usuario_movil: "Gestionar Tipo Usuario Movil",
            titulo_modificar_tipo_vehiculo: "Modificar Tipo Vehículo",
            titulo_crear_tipo_vehiculo: "Crear Tipo Vehículo",
            titulo_gestionar_tipo_vehiculo: "Gestionar Tipo Vehículo",
            titulo_modificar_opcion_respuesta: "Modificar Opcion Respuesta",
            titulo_crear_opcion_respuesta: "Crear Opcion Respuesta",
            titulo_gestionar_opcion_respuesta: "Gestionar Opcion Respuesta",
            titulo_modificar_tipo_checklist: "Modificar Tipo Checklist",
            titulo_crear_tipo_checklist: "Crear Tipo Checklist",
            titulo_gestionar_tipo_checklist: "Gestionar Tipo Checklist",
            titulo_crear_checklist: "Crear Checklist",
            titulo_consolidado_respuestas_checklist: "Consolidado Respuestas Checklist",
            titulo_modificar_usuario_movil: "Modificar Usuario Movil",
            titulo_crear_usuario_movil: "Crear Usuario Movil",
            titulo_lista_usuario_movil: "Lista de Usuario Movil",
            titulo_modificar_usuario_web: "Modificar Usuario Web",
            titulo_crear_usuario_web: "Crear Usuario Web",
            titulo_lista_usuario_web: "Lista de Usuario Web",
            titulo_permisos_sub_tipo_usuario_web: "Permisos Sub Tipo Usuario Web",
            titulo_gestionar_alerta_opcion_respuesta_placa: "Gestionar Alerta Opcion Respuesta - Placa",
            titulo_crear_alerta_opcion_respuesta_placa: "Crear Alerta Opcion Respuesta - Placa",
            titulo_modificar_alerta_opcion_respuesta_placa: "Modificar Alerta Opcion Respuesta - Placa",
            titulo_gestionar_personal_transportar: "Gestionar Personal Transportar",
            titulo_crear_personal_transportar: "Crear Personal Transportar",
            titulo_modificar_personal_transportar: "Modificar Personal Transportar",
            titulo_crear_ruta: "Crear Ruta",
            titulo_modificar_ruta: "Modificar Ruta",
            titulo_crear_persona: "Crear Persona",
            titulo_modificar_persona: "Modificar Persona",
            titulo_crear_riesgo: "Crear Riesgo",
            titulo_modificar_riesgo: "Modificar Riesgo",
            titulo_gestionar_ruta: "Gestionar Ruta",
            titulo_gestionar_persona: "Gestionar Persona",
            titulo_gestionar_riesgo: "Gestionar Riesgo",
            titulo_gestionar_turno: "Gestionar Turno",
            titulo_crear_turno: "Crear Turno",
            titulo_modificar_turno: "Modificar Turno",
            titulo_viaje_checklist: "Viaje",
            titulo_gestionar_estado_viaje: "Gestionar Estado Viaje",
            titulo_crear_estado_viaje: "Crear Estado Viaje",
            titulo_modificar_estado_viaje: "Modificar Estado Viaje",

            btn_buscar: "Buscar",
            btn_atras: "Atrás",
            btn_exportar: "Exportar",
            btn_exportar_excel: "Exportar Excel",
            btn_imprimir: "Imprimir",
            btn_deshabilitar: "Deshabilitar",
            btn_cancelar: "Cancelar",
            btn_aceptar: "Aceptar",
            btn_agregar: "Agregar",
            btn_modificar: "Modificar",
            btn_formulario: "Formulario",
            btn_alertas: "Alertas",
            btn_eliminar_seccion: "Eliminar Sección",
            btn_actualizar: "Actualizar",
            btn_nueva_seccion: "Nueva Sección",
            btn_guardar_preguntas: "Guardar Preguntas",
            btn_ver: "Ver",
            btn_nuevo: "Nuevo",
            btn_eliminar_imagen: "Eliminar Imagen",
            btn_set_default: "Set Default",
            btn_remove_default: "Remove Default",
            btn_guardar: "Guardar",
            btn_eliminar_pregunta: "Eliminar Pregunta",
            btn_confirmar: "Confirmar",
            btn_crear: "Crear",
            btn_cerrar: "Cerrar",
            btn_habilitar: "Habilitar",
            btn_permisos: "Permisos",
            btn_compartir: "Compartir",
            btn_restaurar: "Restaurar",
            btn_exportar_pdf: "Exportar PDF",
            btn_viaje: "Viaje",
            btn_make_default: "Make Default",
            btn_make_un_default: "Make Un Default",

            header_pregunta: "Pregunta",
            header_respuesta: "Respuesta",

            column_vehiculo: "VEHICULO",
            column_acciones: "ACCIONES",
            column_nombre: "NOMBRE",
            column_tipo_checklist: "TIPO CHECKLIST",
            column_manejo_defensivo: "MANEJO DEFENSIVO",
            column_nota: "NOTA",
            column_nombre_checklist: "NOMBRE CHECKLIST",
            column_odometro_actual: "ODOMETRO ACTUAL",
            column_odometro_proximo: "ODOMETRO PROXIMO",
            column_fecha_actual_checklist: "FECHA ACTUAL CHECKLIST",
            column_fecha_proximo_checklist: "FECHA PROXIMO CHECKLIST",
            column_conductor: "CONDUCTOR",
            column_nombre_area: "NOMBRE ÁREA",
            column_ciudad: "CIUDAD",
            column_tipo_vehiculo: "TIPO VEHICULO",
            column_marca_vehiculo: "MARCA VEHICULO",
            column_tipo_carroceria: "TIPO CARROCERIA",
            column_tipo_combustible: "TIPO COMBUSTIBLE",
            column_fecha_proceso: "FECHA PROCESO",
            column_descripcion: "DESCRIPCION",
            column_correo: "EMAIL",
            column_url: "URL",
            column_telefono: "TELEFONO",
            column_enviar_correo: "ENVIAR CORREO",
            column_tomar_foto: "TOMAR FOTO",
            column_nota_observacion: "NOTA/OBSERVACION",
            column_pedir_fecha: "PEDIR FECHA",
            column_critico: "CRITICO",
            column_correos: "CORREOS",
            column_tipo_usuario: "TIPO USUARIO",
            column_apellido_paterno: "APELLIDO PATERNO",
            column_apellido_materno: "APELLIDO MATERNO",
            column_num_lic_conducir: "NUM LIC CONDUCIR",
            column_usuario: "USUARIO",
            column_contrasena: "CONTRASENA",
            column_unidad: "UNIDAD",
            column_apellido: "APELLIDO",
            column_sub_tipo_usuario_web: "SUB TIPO USUARIO WEB",
            column_opcion_respuesta: "OPCION RESPUESTA",
            column_placa: "PLACA VEHICULO",
            column_lista_correos: "LISTA DE CORREOS",
            column_codigo: "CÓDIGO",
            column_inicio: "INICIO",
            column_fin: "FIN",
            column_responsables: "RESPONSABLES",
            column_color: "COLOR",
            column_viaje: "VIAJE",

            select_seleccionar_unidad: "SELECCIONE UNIDAD",
            select_input_odometro_actual: "INPUT ODOMETRO ACTUAL",
            select_input_odometro_proximo_checklist: "INPUT ODOMETRO PROXIMO CHECKLIST",
            select_fecha_actual_checklist: "FECHA ACTUAL CHECKLIST",
            select_fecha_proximo_checklist: "FECHA PROXIMO CHECKLIST",
            select_seleccionar_conductor: "SELECCIONAR CONDUCTOR",
            select_seleccionar_area: "SELECCIONAR ÁREA",
            select_seleccionar_tipo_checklist: "SELECCIONAR TIPO CHECKLIST",
            select_seleccionar_tipo_vehiculo: "SELECCIONAR TIPO VEHICULO",
            select_seleccionar_marca_vehiculo: "SELECCIONAR MARCA VEHICULO",
            select_seleccionar_tipo_carroceria: "SELECCIONAR TIPO CARROCERIA",
            select_seleccionar_tipo_combustible: "SELECCIONAR TIPO COMBUSTIBLE",
            select_seleccionar_ciudad: "SELECCIONAR CIUDAD",
            select_ultimo_odometro_registrado: "ÚLTIMO ODOMETRO REGISTRADO",
            select_ultima_temperatura_registrada: "ÚLTIMA TEMPERATURA REGISTRADA",
            select_seleccionar_nivel_combustible: "SELECCIONAR NIVEL COMBUSTIBLE",
            select_seleccionar_motivo: "SELECCIONAR MOTIVO",
            select_input_numero_de_conocimiento: "INPUT NUMERO DE CONOCIMIENTO",
            select_seleccionar_estado: "SELECCIONAR ESTADO",
            select_seleccione_tipo_usuario: "SELECCIONE TIPO USUARIO",
            select_seleccione_unidad: "SELECCIONE UNIDAD",
            select_seleccione_sub_tipo_usuario: "SELECCIONE SUB TIPO USUÁRIO",
            select_geocerca_origen: "SELECCIONE GEOCERCA ORIGEN",
            select_geocerca_destino: "SELECCIONE GEOCERCA DESTINO",
            select_seleccionar_personal_transportar: "SELECCIONE PERSONAL TRANSPORTAR",
            select_ruta: "SELECCIONE RUTA",
            select_turno: "SELECCIONE TURNO",
            select_input_ruta: "INGRESE RUTA",
            select_input_actividad: "INGRESE ACTIVIDAD",
            select_ida_vuelta_el_mismo_dia: "SELECCIONE IDA Y VUELTA EL MISMO DIA",
            input_fecha_hora_partida: "INGRESE FECHA Y HORA DE PARTIDA",
            input_fecha_hora_llegada: "INGRESE FECHA Y HORA DE LLEGADA",
            input_total_kilometros: "INGRESE TOTAL KILOMETROS",
            input_contacto_destino: "INGRESE CONTACTO DESTINO",
            input_proposito_del_viaje: "INGRESE PROPOSITO DEL VIAJE",
            input_telefono: "INGRESE TELEFONO",
            input_empresa: "INGRESE EMPRESA",
            input_type: "INGRESE TIPO",
            input_propietario: "INGRESE PROPIETARIO",

            input_fecha_programada_de_viaje: "INPUT FECHA PROGRAMADA DE VIAJE",
            input_odometro_proximo_mantenimiento: "ODOMETRO PROXIMO MANTENIMIENTO",

            placeholder_ingresa_descripcion: "Ingrese Descripción",
            placeholder_ingresa_inicio: "Ingrese Inicio",
            placeholder_ingresa_fin: "Ingrese Fin",
            placeholder_ingresa_nota: "Ingrese Nota",
            placeholder_ingresa_codigo: "Ingrese Código",
            placeholder_seleccione_correo: "Seleccione Correo",
            placeholder_seleccione_personas: "Seleccione Responsables",
            placeholder_seleccione_persona_recibe_reporte: "Seleccione Persona que recibe el reporte",
            placeholder_seleccione_responsable_aprobar_riesgo: "Seleccione Responsable para Aprobar Riesgo",
            placeholder_seleccione_estado_viaje: "Seleccione Estado Viaje",
            placeholder_ingrese_su_nombre: "Ingrese Su Nombre",
            placeholder_select_seleccione_grupo: "Seleccione Grupo",
            placeholder_select_seleccione_sub_grupo: "Seleccione Sub Grupo",
            placeholder_select_seleccione_unidades: "Seleccione Unidades",

            select_seleccionar_ruta: "SELECCIONE RUTA",
            input_hora_de_paso: "INGRESE HORA DE PASO",
            input_kilometro: "INGRESE KILOMETRO",
            input_tiempo_descanso: "INGRESE TIEMPO DE DESCANSO",
            select_reportar_ubicacion: "SELECCIONE REPORTAR UBICACION",
            input_observacion: "INGRESE OBSERVACION",
        },
    },
    pt: {
        translation: {
            label_idioma: "Idioma",
            label_plataforma_checklist: "Sistema de Checklist",
            label_usuario: "Usuário",
            label_contrasena: "Senha",
            label_ingresar: "Entrar",
            label_registrarse: "Registar-se",
            label_registrar_usuario: "Registrar Usuario",
            label_nombre: "Nome",
            label_apellido: "Sobrenome",
            label_nota: "Nota",
            label_siguiente: "Próximo",
            label_atras: "Voltar",
            label_crear_cuenta: "Criar Conta",
            label_password: "Senha",
            label_confirmar_password: "Confirmar Senha",
            label_ver_detalles: "Ver Detalhes",
            label_vehiculo: "Veículo",
            label_fecha_registro: "Data de Registro",
            label_secciones: "Seções",
            label_critico: "Crítico",
            label_seleccione_unidad: "Selecione Unidade",
            label_fecha_inicio: "Data de Início",
            label_fecha_fin: "Data de Fim",
            label_cantidad: "Quantidade",
            label_total_critico: "Total Crítico",
            label_si: "Sim",
            label_no: "Não",
            label_codigo: "Código",
            label_enviar_correo: "Enviar Correo",
            label_seleccione_correos: "Selecione Correos",
            label_enviar_mensaje_via_whatsapp: "Enviar Mensagem via WhatsApp",
            label_seleccione_telefonos: "Selecione Telefones",
            label_validar_conductor: "Validar Conductor",
            label_activo: "Ativo",
            label_no_activo: "Inativo",
            label_tipo_input: "Tipo Input",
            label_ejemplo: "Exemplo",
            label_mover_input_arriba: "Mover Input Arriba",
            label_mover_input_abajo: "Mover Input Abajo",
            label_seleccione_input: "Selecione Input",
            label_datos_extra_requeridos: "Dados Extra Requeridos",
            label_respuesta_checklist: "Resposta Checklist",
            label_nombre_checklist: "Nome Checklist",
            label_tipo_checklist: "Tipo Checklist",
            label_area: "Área",
            label_ciudad: "Ciudad",
            label_tipo_vehiculo: "Tipo Vehículo",
            label_marca_vehiculo: "Marca Vehículo",
            label_tipo_carroceria: "Tipo Carroceria",
            label_tipo_combustible: "Tipo Combustible",
            label_nombre_seccion: "Nome Seção",
            label_preguntas: "Perguntas",
            label_seccion_nro: "Número Seção",
            label_manejo_defensivo: "Condução Defensiva",
            label_opciones_respuesta_habilitadas: "Opções Resposta Habilitadas",
            label_opciones_respuesta_deshabilitadas: "Opções Resposta Desabilitadas",
            label_tipo_pregunta: "Tipo Pergunta",
            label_mover_arriba: "Mover Acima",
            label_mover_abajo: "Mover Abaixo",
            label_no_tiene_nombre_seccion: "NÃO TEM NOME SEÇÃO",
            label_numero_pregunta: "Número Pergunta",
            label_no_tiene_titulo_pregunta_descripcion: "NÃO TEM TITULO PREGUNTA/DESCRICAO",
            label_no_tiene_opciones_respuesta: "NÃO TEM OPÇÕES RESPOSTA",
            label_seleccione_tipo_checklist: "Selecione Tipo Checklist",
            label_seccion: "Seção",
            label_eliminar_opcion_respuesta: "Eliminar Opção Resposta",
            label_restaurar_opcion_respuesta: "Restaurar Opção Resposta",
            label_mover_seccion_arriba: "Mover Seção Acima",
            label_mover_seccion_abajo: "Mover Seção Abaixo",
            label_descripcion: "Descrição",
            label_correo: "Email",
            label_subir_imagen: "Subir Imagem",
            label_subir_imagenes_de_tipo: "Subir Imagem de tipo .png o .jpg",
            label_las_imagenes_deben_ser_menor_a_512_kb: "As imagens devem ser menor a 512 KB",
            label_motivo: "Motivo",
            label_nivel_combustible: "Nivel Combustible",
            label_tipo: "Tipo",
            label_firma: "Firma",
            label_obligatorio: "Obrigatório",
            label_no_obligatorio: "Não Obrigatório",
            label_sub_tipo_usuario_web: "Sub Tipo Usuario Web",
            label_telefono: "Teléfono",
            label_debe_ingresar_codigo_de_pais_telefono_sin_espacios: "Você deve inserir código do país + telefone sem espaços",
            label_ejemplo_59176691111: "Exemplo: 59176691111",
            label_tipo_usuario_movil: "Tipo Usuario Movil",
            label_opcion_respuesta: "Opção Resposta",
            label_elegir_color: "Elegir Color",
            label_enviar_correo_si_esta_opcion_es_seleccionada: "Enviar e-mail se esta opção for selecionada",
            label_tomar_foto_si_esta_opcion_es_seleccionada: "Capturar foto se esta opção for selecionada",
            label_pedir_nota_de_descripcion_observacion: "Pedir Nota de Descrição/Observação",
            label_pedir_fecha_si_esta_opcion_es_seleccionada: "Pedir Data se esta opção for selecionada",
            label_opcion_correcta_manejo_defensivo: "Opção Correta Condução Defensiva",
            label_formulario: "Formulário",
            label_pregunta: "Pergunta",
            label_respuesta: "Resposta",
            label_ver_imagen: "Ver Imagem",
            label_ver_foto_respuesta: "Ver Foto Resposta",
            label_pie_de_pagina: "Pé de Página",
            label_pregunta_nro: "Pergunta Nro",
            label_sin_contenido: "Sem Contenido",
            label_unidad: "Unidade",
            label_apellido_paterno: "Sobrenome",
            label_apellido_materno: "Sobrenome",
            label_numero_lic_conducir: "Número Licencia Conducir",
            label_acciones: "Acciones",
            label_validar_odometro: "Validar Odometro",
            label_lista_correos: "Lista de Correos",
            label_nueva_contrasena: "Novo Senha",
            label_ingrese_contrasena: "Enter nova senha",
            label_riesgo: "Risco",
            label_inicio: "Início",
            label_fin: "Fim",
            label_multiple: "Múltiplo",
            label_no_multiple: "Não Múltiplo",
            label_color: "Cor",
            label_responsable_aprobar_riesgo: "Responsável por Aprovar Risco",
            label_persona_recibe_reporte: "Pessoa que recebe o relatório",
            label_otro: "Outro",
            label_no_otro: "Não Outro",
            label_viaje: "Viagem",
            label_orientacion_opciones_respuesta: "Orientação de Opções Resposta",
            label_estado_viaje: "Estado Viaje",
            label_titulo_riesgo: "Título Riesgo",
            label_seleccione_estado_viaje: "Seleccione Estado Viaje",
            label_ingrese_su_nombre: "Ingrese Su Nombre",
            label_persona_hizo_cambio_de_estado: "Persona que hizo el cambio de estado",
            label_grupo: "Grupo",
            label_sub_grupo: "Sub Grupo",
            label_lista_unidades: "Lista Unidades",

            alert_ocurrio_un_error_al_actualizar_la_lista_de_correos: "Ocurrio un error al actualizar la lista de correos",
            alert_ocurrio_un_error_al_actualizar_la_lista_de_telefonos: "Ocurrio un error al actualizar la lista de telefonos",
            alert_usuario_o_contrasena_incorrecto: "Usuário ou senha incorretos",
            alert_debe_ingresar_usuario: "Deve inserir usuário",
            alert_debe_ingresar_password: "Deve inserir senha",
            alert_debe_ingresar_confirmar_password: "Deve inserir confirmar senha",
            alert_passwords_no_coinciden: "As senhas não coincidem",
            alert_no_se_pudo_verificar_usuario: "Não foi possível verificar o usuário",
            alert_usuario_ya_existe: "Usuário já existe",
            alert_se_creo_correctamente: "Criado com sucesso",
            alert_no_se_pudo_crear: "Não foi possível criar",
            alert_debe_ingresar_nombre: "Deve inserir nome",
            alert_debe_ingresar_apellido_paterno: "Deve inserir sobrenome",
            alert_url_copiada_al_portapapeles: "URL copiada para a área de transferência",
            alert_procesado_correctamente: "Processado com sucesso",
            alert_no_se_pudo_procesar: "Não foi possível processar",
            alert_esta_seguro_de_deshabilitar_programacion_alerta: "Está seguro de deshabilitar a programação de alerta?",
            alert_este_tipo_de_input_ya_existe: "Este tipo de input já existe",
            alert_nombre_es_requerido: "Nome é requerido",
            alert_esta_seguro_de_deshabilitar_checklist: "Está seguro de deshabilitar o checklist?",
            alert_no_se_pudo_procesar_intente_nuevamente: "Não foi possível processar, tente novamente",
            alert_confirma_deshabilitar_seccion_nro: "Confirma deshabilitar Seção Nro: ",
            alert_confirma_deshabilitar_pregunta_nro: "Confirma deshabilitar Pergunta Nro: ",
            alert_no_se_pudo_agregar_opcion_respuesta_intente_nuevamente: "Não foi possível adicionar opção de resposta, tente novamente",
            alert_asegurese_que_su_opcion_respuesta_seleccionada_no_se_encuentre_en_opciones_respuesta_habilitadas_deshabilitadas: "Asegurese que sua OPCION RESPOSTA SELECIONADA não se encontre em Opções Resposta Habilitadas/Desabilitadas",
            alert_se_deshabilito_correctamente: "Se desabilitou corretamente",
            alert_no_se_pudo_deshabilitar_opcion_respuesta_intente_nuevamente: "Não foi possível desabilitar opção de resposta, tente novamente",
            alert_confirma_deshabilitar_opcion_respuesta_nro: "Confirma deshabilitar Opção Resposta: ",
            alert_confirma_restaurar_opcion_respuesta_nro: "Confirma restaurar Opção Resposta: ",
            alert_se_restauro_correctamente: "Se restaurou corretamente",
            alert_no_se_pudo_restaurar_opcion_respuesta_intente_nuevamente: "Não foi possível restaurar opção de resposta, tente novamente",
            alert_esta_seguro_de_deshabilitar_respuesta_checklist: "Está seguro de deshabilitar Resposta Checklist?",
            alert_se_modifico_correctamente: "Se modifico correctamente",
            alert_no_se_pudo_modificar: "No se pudo modificar",
            alert_no_se_pudo_deshabilitar: "No se pudo deshabilitar",
            alert_esta_seguro_de_deshabilitar_correo: "Tem certeza de que deseja desabilitar o E-mail?",
            alert_esta_seguro_de_deshabilitar_area: "Tem certeza de que deseja desabilitar a Área",
            alert_esta_seguro_de_deshabilitar_ciudad: "Tem certeza de que deseja desabilitar a cidade?",
            alert_tamaño_de_archivo_excede_limite: "O tamanho do arquivo excede o limite de 500 KB.",
            alert_esta_seguro_de_deshabilitar_icono: "Tem certeza de que deseja desabilitar o ícone?",
            alert_se_elimino_correctamente: "Excluído com sucesso",
            alert_no_se_pudo_eliminar: "Não foi possível excluir",
            alert_se_selecciono_como_default_correctamente: "Selecionado como default com sucesso",
            alert_no_se_pudo_realizar_el_cambio: "Não foi possível realizar o cambio",
            alert_esta_seguro_de_eliminar_imagen: "Tem certeza de que deseja eliminar a imagem?",
            alert_esta_seguro_de_seleccionar_como_imagen_principal_default: "Tem certeza de que deseja selecionar como imagem principal/default?",
            alert_esta_seguro_de_quitar_imagen_principal_default: "Tem certeza de que deseja remover a imagem principal/default?",
            alert_debe_importar_imagen: "Deve importar imagem",
            alert_se_guardo_correctamente: "Salvo com sucesso",
            alert_no_se_pudo_guardar_imagen: "Não foi possível salvar a imagem, por favor revise que a resolução não seja maior a 566x360",
            alert_formato_de_archivo_no_valido: "Formato de arquivo inválido. Por favor, selecione um arquivo .jpg ou .png.",
            alert_esta_seguro_de_deshabilitar_marca_vehiculo: "Tem certeza de que deseja desabilitar a marca do veículo?",
            alert_esta_seguro_de_deshabilitar_motivo: "Tem certeza de que deseja desabilitar o motivo?",
            alert_esta_seguro_de_deshabilitar_nivel_combustible: "Tem certeza de que deseja desabilitar o nível de combustível?",
            alert_esta_seguro_de_deshabilitar_formulario: "Tem certeza de que deseja desabilitar o formulário?",
            alert_no_se_pudo_agregar_nuevo_input: "Não foi possível adicionar novo input",
            alert_no_se_pudo_actualizar_todos_los_inputs_intente_nuevamente: "Não foi possível atualizar todos os inputs, tente novamente",
            alert_se_actualizo_correctamente: "Atualizado com sucesso",
            alert_esta_seguro_de_deshabilitar_sub_tipo_usuario_web: "Tem certeza de que deseja desabilitar Sub Tipo Usuario Web?",
            alert_esta_seguro_de_deshabilitar_telefono: "Tem certeza de que deseja desabilitar o telefone?",
            alert_esta_seguro_de_deshabilitar_tipo_carroceria: "Tem certeza de que desabilitar Tipo Carroceria?",
            alert_esta_seguro_de_deshabilitar_tipo_combustible: "Tem certeza de que desabilitar Tipo Combustible?",
            alert_esta_seguro_de_deshabilitar_tipo_usuario_movil: "Tem certeza de que desabilitar Tipo Usuario Movil?",
            alert_esta_seguro_de_deshabilitar_tipo_vehiculo: "Tem certeza de que desabilitar Tipo Vehículo?",
            alert_esta_seguro_de_deshabilitar_opcion_respuesta: "Tem certeza de que desabilitar Opção Resposta?",
            alert_esta_seguro_de_deshabilitar_tipo_checklist: "Tem certeza de que desabilitar Tipo Checklist?",
            alert_debe_seleccionar_tipo_checklist: "Deve selecionar tipo checklist",
            alert_debe_seleccionar_unidad: "Deve selecionar unidade",
            alert_debe_seleccionar_fechas_validas: "Deve selecionar datas válidas",
            alert_esta_seguro_de_deshabilitar_usuario: "Tem certeza de que desabilitar Usuário?",
            alert_esta_seguro_de_habilitar_usuario: "Tem certeza de que habilitar Usuário?",
            alert_se_proceso_correctamente: "Se processou corretamente",
            alert_procesando_solicitud: "Procesando solicitud...",
            alert_esta_seguro_de_deshabilitar: "Tem certeza de que desabilitar?",
            alert_debe_ingresar_contrasena_de_5_caracteres_minimo: "Deve inserir 5 caracteres como minimo",
            alert_debe_ingresar_descripcion: "Deve inserir descrição",
            alert_se_cambio_estado_viaje_correctamente: "Se cambió estado viaje correctamente",
            alert_debe_ingresar_datos: "Deve inserir dados",

            menu_dashboard: "Dashboard",
            menu_usuarios: "Usuários",
            menu_usuarios_web: "Usuários Web",
            menu_usuarios_movil: "Usuários Movil",
            menu_configuracion: "Configuração",
            menu_reportes: "Relatórios",
            menu_salir: "Sair",
            menu_mis_checklist: "Meus Checklist",
            menu_respuestas_checklist: "Respostas Checklist",
            menu_permisos: "Permisos",
            menu_administracion: "Administrar",
            menu_personal_transportar: "Transporte Personal",
            menu_ruta: "Ruta",
            menu_persona: "Persona",
            menu_riesgo: "Riesgo",
            menu_turno: "Turno",
            menu_estado_viaje: "Estado Viaje",

            titulo_opciones_respuesta_seleccionadas: "Opções Resposta Selecionadas",
            titulo_vehiculos_sin_checklist: "Veículos Sem Checklist",
            titulo_vehiculos_con_checklist: "Veículos Com Checklist",
            titulo_sin_checklist: "Sem Checklist",
            titulo_con_checklist: "Com Checklist",
            titulo_vehiculos_que_realizaron_checklist: "Veículos Que Realizaram Checklist",
            titulo_exportar_grafico: "Exportar Gráfico",
            titulo_detalle_checklist: "Detalhes do Checklist",
            titulo_respuestas_checklist: "Respostas Checklist",
            titulo_alertas_checklist: "Alertas Checklist",
            titulo_alertas: "Alertas",
            titulo_formulario_checklist: "Formulário Checklist",
            titulo_gestionar_mis_checklist: "Gerenciar Meus Checklist",
            titulo_eliminar_seccion: "Eliminar Seção",
            titulo_firma: "Firma",
            titulo_imagen: "Imagem",
            titulo_comentario: "Comentário",
            titulo_preguntas_checklist: "Perguntas Checklist",
            titulo_guardar_preguntas: "Salvar Perguntas",
            titulo_detalle_respuestas_checklist: "Detalhes de Resposta Checklist",
            titulo_lista_respuestas_checklist: "Lista Respostas Checklist",
            titulo_modificar_correo: "Modificar Correo",
            titulo_crear_correo: "Criar Correo",
            titulo_gestionar_correos: "Gerenciar E-mails",
            titulo_modificar_area: "Modificar Area",
            titulo_crear_area: "Criar Area",
            titulo_gestionar_area: "Gerenciar Area",
            titulo_ciudad: "Cidade",
            titulo_modificar_ciudad: "Modificar Cidade",
            titulo_crear_ciudad: "Criar Cidade",
            titulo_gestionar_ciudad: "Gerenciar Cidade",
            titulo_agregar_icono: "Adicionar Ícone",
            titulo_gestionar_iconos: "Gerenciar Ícones",
            titulo_nuevo_logo: "Novo Logo",
            titulo_gestionar_logo: "Gerenciar Logo",
            titulo_modificar_marca_vehiculo: "Modificar Marca Vehículo",
            titulo_crear_marca_vehiculo: "Criar Marca Vehículo",
            titulo_gestionar_marca_vehiculo: "Gerenciar Marca Vehículo",
            titulo_modificar_motivo: "Modificar Motivo",
            titulo_crear_motivo: "Criar Motivo",
            titulo_gestionar_motivo: "Gerenciar Motivo",
            titulo_modificar_nivel_combustible: "Modificar Nivel Combustible",
            titulo_crear_nivel_combustible: "Criar Nivel Combustible",
            titulo_gestionar_nivel_combustible: "Gerenciar Nivel Combustible",
            titulo_modificar_formulario_pie_de_pagina: "Modificar Formulário Rodapé",
            titulo_gestionar_pie_de_pagina: "Gerenciar Rodapé",
            titulo_nuevo_pie_de_pagina: "Novo Rodapé",
            titulo_modificar_sub_tipo_usuario_web: "Modificar Sub Tipo Usuario Web",
            titulo_crear_sub_tipo_usuario_web: "Criar Sub Tipo Usuario Web",
            titulo_gestionar_sub_tipo_usuario_web: "Gerenciar Sub Tipo Usuario Web",
            titulo_modificar_telefono: "Modificar Telefono",
            titulo_crear_telefono: "Criar Telefono",
            titulo_gestionar_telefono: "Gerenciar Telefono",
            titulo_modificar_tipo_carroceria: "Modificar Tipo Carroceria",
            titulo_crear_tipo_carroceria: "Criar Tipo Carroceria",
            titulo_gestionar_tipo_carroceria: "Gerenciar Tipo Carroceria",
            titulo_modificar_tipo_combustible: "Modificar Tipo Combustible",
            titulo_crear_tipo_combustible: "Criar Tipo Combustible",
            titulo_gestionar_tipo_combustible: "Gerenciar Tipo Combustible",
            titulo_modificar_tipo_usuario_movil: "Modificar Tipo Usuario Movil",
            titulo_crear_tipo_usuario_movil: "Criar Tipo Usuario Movil",
            titulo_gestionar_tipo_usuario_movil: "Gerenciar Tipo Usuario Movil",
            titulo_modificar_tipo_vehiculo: "Modificar Tipo Vehículo",
            titulo_crear_tipo_vehiculo: "Criar Tipo Vehículo",
            titulo_gestionar_tipo_vehiculo: "Gerenciar Tipo Vehículo",
            titulo_modificar_opcion_respuesta: "Modificar Opção Resposta",
            titulo_crear_opcion_respuesta: "Criar Opção Resposta",
            titulo_gestionar_opcion_respuesta: "Gerenciar Opção Resposta",
            titulo_modificar_tipo_checklist: "Modificar Tipo Checklist",
            titulo_crear_tipo_checklist: "Criar Tipo Checklist",
            titulo_gestionar_tipo_checklist: "Gerenciar Tipo Checklist",
            titulo_crear_checklist: "Criar Novo Checklist",
            titulo_consolidado_respuestas_checklist: "Consolidado Respuestas Checklist",
            titulo_modificar_usuario_movil: "Modificar usuário móvel",
            titulo_crear_usuario_movil: "Criar usuário móvel",
            titulo_lista_usuario_movil: "Lista de usuário móvel",
            titulo_modificar_usuario_web: "Modificar usuário web",
            titulo_crear_usuario_web: "Criar usuário web",
            titulo_lista_usuario_web: "Lista de usuário web",
            titulo_permisos_sub_tipo_usuario_web: "Permissões de Subtipo de Usuário Web",
            titulo_gestionar_alerta_opcion_respuesta_placa: "Gerenciar Alerta Opção Resposta - Placa",
            titulo_crear_alerta_opcion_respuesta_placa: "Criar Alerta Opção Resposta - Placa",
            titulo_modificar_alerta_opcion_respuesta_placa: "Modificar Alerta Opção Resposta - Placa",
            titulo_gestionar_personal_transportar: "Gerenciar Transporte Personal",
            titulo_crear_personal_transportar: "Criar Transporte Personal",
            titulo_modificar_personal_transportar: "Modificar Transporte Personal",
            titulo_crear_ruta: "Criar Rota",
            titulo_modificar_ruta: "Modificar Rota",
            titulo_crear_persona: "Criar Pessoa",
            titulo_modificar_persona: "Modificar Pessoa",
            titulo_crear_riesgo: "Criar Risco",
            titulo_modificar_riesgo: "Modificar Risco",
            titulo_gestionar_ruta: "Gerenciar Rota",
            titulo_gestionar_persona: "Gerenciar Pessoa",
            titulo_gestionar_riesgo: "Gerenciar Risco",
            titulo_gestionar_turno: "Gerenciar Turno",
            titulo_crear_turno: "Criar Turno",
            titulo_modificar_turno: "Modificar Turno",
            titulo_viaje_checklist: "Viaje",
            titulo_gestionar_estado_viaje: "Gerenciar Estado Viaje",
            titulo_crear_estado_viaje: "Criar Estado Viaje",
            titulo_modificar_estado_viaje: "Modificar Estado Viaje",

            btn_buscar: "Buscar",
            btn_atras: "Voltar",
            btn_exportar: "Exportar",
            btn_exportar_excel: "Exportar Excel",
            btn_imprimir: "Imprimir",
            btn_deshabilitar: "Deshabilitar",
            btn_cancelar: "Cancelar",
            btn_aceptar: "Aceptar",
            btn_agregar: "Agregar",
            btn_modificar: "Modificar",
            btn_formulario: "Formulario",
            btn_alertas: "Alertas",
            btn_actualizar: "Actualizar",
            btn_nueva_seccion: "Nova Seção",
            btn_guardar_preguntas: "Salvar Perguntas",
            btn_ver: "Ver",
            btn_nuevo: "Novo",
            btn_eliminar_imagen: "Eliminar Imagem",
            btn_set_default: "Set Default",
            btn_remove_default: "Remove Default",
            btn_guardar: "Salvar",
            btn_eliminar_pregunta: "Excluir Pergunta",
            btn_confirmar: "Confirmar",
            btn_crear: "Criar",
            btn_cerrar: "Fechar",
            btn_habilitar: "Ativar",
            btn_permisos: "Permissões",
            btn_compartir: "Compartir",
            btn_restaurar: "Restaurar",
            btn_exportar_pdf: "Exportar PDF",
            btn_viaje: "Viagem",
            btn_make_default: "Make Default",
            btn_make_un_default: "Make Un Default",

            header_pregunta: "Pergunta",
            header_respuesta: "Resposta",

            column_vehiculo: "VEICULO",
            column_acciones: "AÇÕES",
            column_nombre: "NOME",
            column_tipo_checklist: "TIPO CHECKLIST",
            column_manejo_defensivo: "CONDUÇÃO DEFENSIVA",
            column_nota: "NOTA",
            column_nombre_checklist: "NOME CHECKLIST",
            column_odometro_actual: "ODOMETRO ACTUAL",
            column_odometro_proximo: "ODOMETRO PROXIMO",
            column_fecha_actual_checklist: "DATA CHECKLIST ATUAL",
            column_fecha_proximo_checklist: "DATA PROXIMO CHECKLIST",
            column_conductor: "CONDUCTOR",
            column_nombre_area: "NOME ÁREA",
            column_ciudad: "CIDADE",
            column_tipo_vehiculo: "TIPO VEHICULO",
            column_marca_vehiculo: "MARCA VEHICULO",
            column_tipo_carroceria: "TIPO CARROCERIA",
            column_tipo_combustible: "TIPO COMBUSTIBLE",
            column_fecha_proceso: "DATA PROCESO",
            column_descripcion: "DESCRIÇÃO",
            column_correo: "EMAIL",
            column_url: "URL",
            column_telefono: "TELEFONO",
            column_enviar_correo: "ENVIAR E-MAIL",
            column_tomar_foto: "TIRAR FOTO",
            column_nota_observacion: "OBSERVAÇÃO",
            column_pedir_fecha: "SOLICITAR DATA",
            column_critico: "CRITICO",
            column_correos: "E-MAILS",
            column_tipo_usuario: "TIPO DE USUÁRIO",
            column_apellido_paterno: "SOBRENOME",
            column_apellido_materno: "SOBRENOME",
            column_num_lic_conducir: "Nº DA LICENÇA DE CONDUÇÃO",
            column_usuario: "USUÁRIO",
            column_contrasena: "SENHA",
            column_unidad: "UNIDADE",
            column_apellido: "SOBRENOME",
            column_sub_tipo_usuario_web: "SUB TIPO USUÁRIO WEB",
            column_opcion_respuesta: "OPCION RESPUESTA",
            column_placa: "PLACA VEHICULO",
            column_lista_correos: "LISTA DE CORREOS",
            column_codigo: "CÓDIGO",
            column_inicio: "INICIO",
            column_fin: "FIN",
            column_responsables: "RESPONSABLES",
            column_color: "COLOR",
            column_viaje: "VIAJE",

            select_seleccionar_unidad: "SELECIONE UNIDADE",
            select_input_odometro_actual: "INPUT ODOMETRO ACTUAL",
            select_input_odometro_proximo_checklist: "INPUT ODOMETRO PROXIMO CHECKLIST",
            select_fecha_actual_checklist: "FECHA ACTUAL CHECKLIST",
            select_fecha_proximo_checklist: "FECHA PROXIMO CHECKLIST",
            select_seleccionar_conductor: "SELECCIONAR CONDUCTOR",
            select_seleccionar_area: "SELECCIONAR ÁREA",
            select_seleccionar_tipo_checklist: "SELECCIONAR TIPO CHECKLIST",
            select_seleccionar_tipo_vehiculo: "SELECCIONAR TIPO VEHICULO",
            select_seleccionar_marca_vehiculo: "SELECCIONAR MARCA VEHICULO",
            select_seleccionar_tipo_carroceria: "SELECCIONAR TIPO CARROCERIA",
            select_seleccionar_tipo_combustible: "SELECCIONAR TIPO COMBUSTIBLE",
            select_seleccionar_ciudad: "SELECCIONAR CIUDAD",
            select_ultimo_odometro_registrado: "ÚLTIMO ODOMETRO REGISTRADO",
            select_ultima_temperatura_registrada: "ÚLTIMA TEMPERATURA REGISTRADA",
            select_seleccionar_nivel_combustible: "SELECCIONAR NIVEL COMBUSTIBLE",
            select_seleccionar_motivo: "SELECCIONAR MOTIVO",
            select_input_numero_de_conocimiento: "INPUT NUMERO DE CONOCIMIENTO",
            select_seleccionar_estado: "SELECCIONAR ESTADO",
            select_seleccione_tipo_usuario: "SELECIONE O TIPO DE USUÁRIO",
            select_seleccione_unidad: "SELECCIONE UNIDADE",
            select_seleccione_sub_tipo_usuario: "SELECCIONE SUB TIPO USUÁRIO",
            select_geocerca_origen: "SELECCIONE GEOCERCA ORIGEN",
            select_geocerca_destino: "SELECCIONE GEOCERCA DESTINO",
            select_seleccionar_personal_transportar: "SELECCIONE PERSONAL TRANSPORTAR",
            select_ruta: "SELECCIONE RUTA",
            select_turno: "SELECCIONE TURNO",
            select_input_ruta: "INPUT RUTA",
            select_input_actividad: "INPUT ACTIVIDAD",
            select_ida_vuelta_el_mismo_dia: "SELECCIONE IDA Y VUELTA EL MISMO DIA",
            input_fecha_hora_partida: "INGRESE FECHA Y HORA DE PARTIDA",
            input_fecha_hora_llegada: "INGRESE FECHA Y HORA DE LLEGADA",
            input_total_kilometros: "INGRESE TOTAL KILOMETROS",
            input_contacto_destino: "INGRESE CONTACTO DESTINO",
            input_proposito_del_viaje: "INGRESE PROPOSITO DEL VIAJE",
            input_telefono: "INGRESE TELEFONO",
            input_empresa: "INGRESE EMPRESA",
            input_type: "INGRESE TIPO",
            input_propietario: "INGRESE PROPIETARIO",

            input_fecha_programada_de_viaje: "INPUT FECHA PROGRAMADA DE VIAJE",
            input_odometro_proximo_mantenimiento: "ODOMETRO PROXIMO MANTENIMIENTO",

            placeholder_ingresa_descripcion: "Ingrese Descripción",
            placeholder_ingresa_inicio: "Ingrese Inicio",
            placeholder_ingresa_fin: "Ingrese Fin",
            placeholder_ingresa_nota: "Ingrese Nota",
            placeholder_ingresa_codigo: "Ingrese Código",
            placeholder_seleccione_correo: "Seleccione Correo",
            placeholder_seleccione_personas: "Seleccione Responsables",
            placeholder_seleccione_persona_recibe_reporte: "Seleccione Persona que recibe el reporte",
            placeholder_seleccione_responsable_aprobar_riesgo: "Seleccione Responsable para Aprobar Riesgo",
            placeholder_seleccione_estado_viaje: "Seleccione Estado Viaje",
            placeholder_ingrese_su_nombre: "Ingrese Su Nombre",
            placeholder_select_seleccione_grupo: "Seleccione Grupo",
            placeholder_select_seleccione_sub_grupo: "Seleccione Sub Grupo",
            placeholder_select_seleccione_unidades: "Seleccione Unidades",

            select_seleccionar_ruta: "SELECCIONE RUTA",
            input_hora_de_paso: "INGRESE HORA DE PASO",
            input_kilometro: "INGRESE KILOMETRO",
            input_tiempo_descanso: "INGRESE TIEMPO DE DESCANSO",
            select_reportar_ubicacion: "SELECCIONE REPORTAR UBICACION",
            input_observacion: "INGRESE OBSERVACION",
        },
    }
};

i18n
    .use(initReactI18next) // Passes i18n instance to react-i18next
    .init({
        resources,
        lng: "es", // Set default language
        fallbackLng: "es", // Fallback if the selected language isn't available
        interpolation: {
            escapeValue: false, // React already escapes values
        },
    });

export default i18n;
